import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class CapacityDataProvider extends Controller {
  @service('roadmap') roadmapService;

  get roadmap() {
    return this.roadmapService.get('selected');
  }

  get initiatives() {
    return this.roadmapService.initiatives;
  }

  get scenario() {
    return this.roadmapService.investmentScenario;
  }

  get roadmap_id() {
    return this.roadmap?.id;
  }
}
